import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

const getSession = () => {
  const storageRaw = sessionStorage.getItem('ddesp');
  if (!storageRaw) return { emp: 0, uid: 0 };

  const usersRt = base64_decode(storageRaw);
  const users = JSON.parse(usersRt);
  return {
    emp: users?.[0] || 0,
    uid: users?.[3] || 0,
  };
};

export const RestIntegracoesGet = async (config) => {
  const caminho = String(config?.dest || '').trim();
  const users = sessionStorage.getItem('ddesp');
  const { emp, uid } = getSession();
  const token = users ? JSON.parse(base64_decode(users))?.[14] : '';

  switch (caminho) {
    case 'webhook_eventos':
    case 'webhookEventos':
    case 'webhook_events': {
      return new Promise((resolve, reject) => {
        try {
          const payload = config?.dataPost || {};
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('integracoes'),
              ll: base64_encode('webhook_eventos'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, { message: 'Falha na requisição', details }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'webhook_listar':
    case 'webhookListar':
    case 'webhook_list': {
      return new Promise((resolve, reject) => {
        try {
          const payload = config?.dataPost || {};
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('integracoes'),
              ll: base64_encode('webhook_listar'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
              
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, { message: 'Falha na requisição', details }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'webhook_entregas':
    case 'webhookEntregas':
    case 'webhook_logs': {
      return new Promise((resolve, reject) => {
        try {
          const payload = config?.dataPost || {};
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('integracoes'),
              ll: base64_encode('webhook_entregas'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, { message: 'Falha na requisição', details }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export const RestIntegracoesPost = async (config) => {
  const users = sessionStorage.getItem('ddesp');
  const { emp, uid } = getSession();
  const token = users ? JSON.parse(base64_decode(users))?.[14] : '';

  const Arr_ = typeof config?.data === 'string' ? JSON.parse(config.data) : (config?.data || {});
  const caminho = String(Arr_?.dest || '').trim();
  const payload = Arr_?.dataPost || {};

  switch (caminho) {
    case 'webhook_cadastrar':
    case 'webhookCadastrar':
    case 'webhook_create': {
      return new Promise((resolve, reject) => {
        try {
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('integracoes'),
              ll: base64_encode('webhook_cadastrar'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, { message: 'Falha na requisição', details }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'webhook_deletar':
    case 'webhookDeletar':
    case 'webhook_delete': {
      return new Promise((resolve, reject) => {
        try {
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('integracoes'),
              ll: base64_encode('webhook_deletar'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, { message: 'Falha na requisição', details }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'webhook_disparar_teste':
    case 'webhookDispararTeste': {
      return new Promise((resolve, reject) => {
        try {
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('integracoes'),
              ll: base64_encode('webhook_disparar_teste'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, { message: 'Falha na requisição', details }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    case 'apiv1_try': {
      return new Promise((resolve, reject) => {
        try {
          const dataPost_ = [base64_encode(String(emp)), base64_encode(String(uid)), base64_encode(JSON.stringify(payload))];

          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('integracoes'),
              ll: base64_encode('apiv1_try'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: function (data) {
              try {
                const out = JSON.parse(base64_decode(data));
                resolve([200, out]);
              } catch {
                reject([400, { message: 'Resposta inválida' }]);
              }
            },
            error: function (xhr) {
              const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
              reject([400, { message: 'Falha na requisição', details }]);
            },
          });
        } catch (err) {
          reject([500, { message: String(err) }]);
        }
      });
    }

    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};
